import React, { Fragment, useState, useEffect } from "react";
import { themeStyle } from "../components/Components.js";
import { Redirect } from "react-router-dom";
import { logout } from "../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  alertMessage,
  DOMAIN_URL,
  SIDEBAR,
  GRADIENT,
  ONLYLOGO,
  APPBAR,
} from "../actions/auth";

export default function Expired() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <Fragment>
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "opacity 1s",
          opacity: loaded ? 1 : 0,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: GRADIENT,
            height: "100%",
            paddingTop: "50px",
          }}
        >
          <AppBar
            position="fixed"
            style={{
              backgroundColor: "white",
            }}
          >
            <Toolbar
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {" "}
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <img
                  style={{ maxHeight: "50px", margin: "10px" }}
                  src={require("../img/" + APPBAR)}
                />
              </a>
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "16px",
                    marginTop: "3px",
                  }}
                >
                  <ChevronLeftIcon style={{ fontSize: "35px" }} /> Back to Home
                </Button>
              </a>
            </Toolbar>
          </AppBar>
          <div
            style={{
              padding: "50px",
              backgroundColor: "white",
              textAlign: "center",
              borderRadius: "6px",
            }}
          >
            <div style={{ marginTop: "-30px" }}>Subscription expired.</div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
